import { render, staticRenderFns } from "./post-change-wallpaper.vue?vue&type=template&id=25dfaff5"
import script from "./post-change-wallpaper.vue?vue&type=script&lang=js"
export * from "./post-change-wallpaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports